import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class ReconnectTimeoutError extends BaseError {
    constructor(loggerFields: SafeLogErrorOptions) {
        super('Reconnect timeout error', loggerFields);

        Object.setPrototypeOf(this, ReconnectTimeoutError.prototype);
    }
}
